import { render, staticRenderFns } from "./OneProjectLimits.vue?vue&type=template&id=7ac3da5e&scoped=true"
import script from "./OneProjectLimits.vue?vue&type=script&lang=js"
export * from "./OneProjectLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac3da5e",
  null
  
)

export default component.exports